import {CommonReducer, ReducerFromState} from "../../@types/reducers";

export const getEventBookmakers = (state: ReducerFromState<CommonReducer>): number[] => state.common.eventBookmaker;